import ApiService from '@/services/api.service'

const ProviderService = {
    
    getAll(UserId){      
        return ApiService.get(`/providers?UserId=${UserId}&IncludeTraining=true`); 
    },
    get(id){      
        return ApiService.get(`/providers/${id}`); 
    },

    getFullProvidersNoTraining(){
        return ApiService.get(`/providers?IncludeTraining=true`); 
    },

    SelectProvider(code){
        return ApiService.post(`/auth/provider/`,code)
    }

}

export default ProviderService;